export abstract class IdentifiableObjectDTO<T> {

  public id: T;

}
